import { FormSelectOption, SearchableSelectOption } from "@thecb/components";
import { SELECT_ALL } from "./constants";

export const formSelectToSearchableSelectOptions = (
  formSelectOptions: FormSelectOption[]
): SearchableSelectOption[] =>
  formSelectOptions.map((o) => ({
    name: o.text,
    value: o.value,
  }));

export const handleSelect = (
  selection: SearchableSelectOption,
  currentSelections: SearchableSelectOption[],
  setCurrentSelections: (selections: SearchableSelectOption[]) => void
) => {
  if (selection.name === SELECT_ALL) {
    // This case is handled in the SearchableSelect CB component's `handleSelect` method
    return;
  }
  if (
    currentSelections &&
    currentSelections.find((l) => l.value === selection.value)
  ) {
    const filtered = currentSelections.filter((l) => l.value !== selection.value);
    setCurrentSelections(filtered);
  } else {
    setCurrentSelections([...currentSelections, selection]);
  }
};

export const handleSelectAll = (
  isSelectAll: boolean,
  allOptions: SearchableSelectOption[],
  setCurrentSelections: (selections: SearchableSelectOption[]) => void
) => {
  isSelectAll && allOptions
    ? setCurrentSelections(
        allOptions.concat({
          name: SELECT_ALL,
          value: SELECT_ALL,
        })
      )
    : setCurrentSelections([]);
};
